export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":"Откройте для себя инновационную платформу, которая меняет правила игры в найме. Кандидаты и работодатели могут взаимодействовать через короткие видеоролики, делая найм более персональным и эффективным. - sobes.ru"}],"link":[],"style":[],"script":[{"key":"dataLayer","innerHTML":"window.dataLayer = window.dataLayer || [];"},{"key":"yandex-metrika-ym","innerHTML":"(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};m[i].l=1*new Date();for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})(window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\");ym(95359767, \"init\", {clickmap:true,trackLinks:true,accurateTrackBounce:true,webvisor:true});"}],"noscript":[{"key":"yandex-metrika-noscript","innerHTML":"<div><img src=\"https://mc.yandex.ru/watch/95359767\" style=\"position:absolute; left:-9999px;\" alt=\"\" /></div>"}],"title":"Вакансии и резюме в видеоформате. Будущее найма - sobes.ru","htmlAttrs":{"lang":"ru-RU"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000